export const createInflightRegistry = () => {
    const active = new Map();
    const listeners = new Set();
    const total = () => [...active.values()].reduce((sum, copies) => sum + copies, 0);
    const notify = () => listeners.forEach(listener => listener(total()));
    return {
        add: (id) => {
            active.set(id, (active.get(id) || 0) + 1);
            notify();
        },
        remove: (id) => {
            const copies = (active.get(id) || 0) - 1;
            if (copies > 0) active.set(id, copies);
            else active.delete(id);
            notify();
        },
        count: () => total(),
        has: (id) => active.has(id),
        subscribe: (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
    };
};

export const inflightRegistry = createInflightRegistry();
